import React from "react";
import { Layout } from "Components/Layout/Layout";
import { BidDetails } from "Containers/Bids/BidDetails/BidDetails";

export const BidDetailsPage: React.FC = () => {
  return (
    <Layout>
      <BidDetails />
    </Layout>
  );
};
